import { render } from "./BookingResultsView.vue?vue&type=template&id=06d8ff06&scoped=true&ts=true"
import script from "./BookingResultsView.vue?vue&type=script&lang=ts"
export * from "./BookingResultsView.vue?vue&type=script&lang=ts"

import "./BookingResultsView.vue?vue&type=style&index=0&id=06d8ff06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d8ff06"]])

export default __exports__